export default {
  baseStyle: {
    textTransform: 'none',
    color: 'gray.400',
  },
};
